<template>
    <div class="common-layout">
        <el-container>
        <el-header>
            <img class="logo" src="../../static/logo.png" />
            <div class="menu">
                <span :class="{ active: ['Examlist','Addplan','Studentlist','Createpaper'].includes(selectPage) }" @click="changeTable('Examlist')">考试管理</span>
                <span v-if="userinfo.type" :class="{ active: ['Questionbank','Questionlist'].includes(selectPage) }" @click="changeTable('Questionbank')">题库</span>
            </div>
            <div class="login_box">
                <span>{{ userinfo.name }}</span>
                <el-divider direction="vertical"></el-divider>
                <span @click="loginout" style="color: #409EFF;">退出</span>
            </div>
        </el-header>
        <el-container>
        <el-aside>
            <div class="user_info">
                <el-row>
                    <el-col :span="12">
                        <img style="width: 70px; height: 70px;float: left;" src="../../static/txda.png" />
                    </el-col>
                    <el-col class="user_name" :span="12">
                        <span style="vertical-align: middle;font-size: 16px;"> {{ userinfo.name }} </span>
                    </el-col>
                </el-row>
                <el-row class="user_row">
                    <el-col class="left" :span="12">
                        用户名
                    </el-col>
                    <el-col class="right" :span="12">
                        {{ userinfo.username }}
                    </el-col>
                </el-row>
                <el-row class="user_row">
                    <el-col class="left" :span="12">
                        学校
                    </el-col>
                    <el-col class="right" :span="12">
                        {{ userinfo.school_id_text }}
                    </el-col>
                </el-row>
            </div>

            <div class="user_message">
                <div class="title_lable">
                    <el-icon style="font-size: 24px;color: #409EFF;margin-right: 10px;float: left;" class="el-icon-s-platform"></el-icon>
                    <span>我的消息</span>
                </div>
                <el-empty description="暂无消息" />
                <!-- <div class="message">
                    <div class="message_title">
                        <span class="left">考试通知</span>
                        <span class="right">2024-11-10</span>
                    </div>
                    <div class="message_body">
                        某某某老师,对公共英语基础01班、公共英语基础02班、公共英语基础03班,发布了考试。考试时间:2024-11-1510:00~12:00
                    </div>
                </div> -->
                
            </div>
        </el-aside>
        <el-main>
            <slot></slot>
        </el-main>
        </el-container>
    </el-container>
    </div>
    
</template>
<script>
import axios from 'axios';
import Http from "../apis/user";
export default {
    data(){
        return{
            userinfo:{},
            avatar:'',
            selectPage:'Examlist'
        }
    },
    activated(){
        if(this.$router.currentRoute.name){
            this.selectPage = this.$router.currentRoute.name
        }
        var userinfo = JSON.parse(localStorage.getItem('userinfo'))
        this.userinfo = userinfo
        this.avatar = axios.defaults.fileURL+userinfo.avatar
    },
    methods:{
        changeTable(index){
            this.selectPage = index
            if(index == 'Questionbank'){
                this.$router.push({ name: 'Questionbank' });
            }else{
                this.$router.push({ name: 'Examlist' });
            }
        },

        loginout(){
            //
            Http.Logout().then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message:res.msg
                });
                if(res.code){
                    localStorage.clear();
                    this.$router.push({ name: 'Login' });
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
.login_box{
    float: right;line-height: 60px;

    span{
        cursor: pointer;
    }
}
.common-layout{
    width: 100%;
    height: 100%;
}
.common-layout{

    .user_info{
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;

        .left{
            text-align: left;
            opacity: 0.7;
        }
        .right{
            text-align: right;
        }

        .user_row{
            margin-top: 15px;
        }
    }

    .user_message{
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        margin-top: 20px;

        .title_lable{
            display: inline-block;
            width: 100%;
            font-size: 16px;
            span{
                float: left;
                line-height: 26px;
                font-size: 16px;
            }
        }
        .message_title{
            display: inline-block;
            width: 100%;
            margin-top: 20px;

            .left{
                float: left;
                font-size: 16px;
                color: #5191BE;
            }
            .right{
                float: right;
                opacity: 0.7;
                font-size: 14px;
            }
        }

        .message_body{
            width: 100%;
            margin-top: 10px;
            opacity: 0.7;
            line-height: 25px;
            font-size: 14px;
            text-indent: 20px;
        }
    }
    .user_name{
        text-align: right;
        line-height: 70px;
    }
    .active{
        border-bottom: 1.5px #409EFF solid;
        color: #409EFF;
        padding-bottom: 19px;
    }
    .logo{
        float: left;
        margin-right: 50px;
        margin-left: 20px;
        margin-top: 6px;
    }

    .menu{
        float: left;
        
        line-height: 60px;

        span{
            height: 60px !important;
            line-height: 60px;
            margin-right: 15px;
            cursor: pointer;
        }
    }

    .el-header{
        background: #ffffff;
        margin-bottom: 20px;
    }
    .el-aside{
        width: 400px !important;
        margin-left: 20px;
    }
    .el-main{
        background: #ffffff;
        margin-left: 20px;
        margin-right: 20px;
    }
}
@media screen and (max-width: 768px) {
    .common-layout {
        display: flex;
        flex-direction: column;

        .el-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 10px;

            .logo {
                float: none;
                margin: 10px 0;
            }

            .menu {
                float: none;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                line-height: 40px;

                span {
                    margin: 0 10px;
                }
            }

            .login_box {
                float: none;
                line-height: 40px;
            }
        }
        .user_message{
            display: none;
        }
        .el-container {
            flex-direction: column;

            .el-aside {
                width: 100% !important;
                margin-left: 0;
            }

            .el-main {
                margin: 10px 0;
            }
        }
    }
}
</style>